

<script setup >
    import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import Foot from '../components/Foot';
import HeadBar from '../components/HeadBar';
import Share from '../components/Share';
import { imageUrl } from '../composables/http';
import useInnerBlog from '../composables/useInnerBlog';
import { isNullOrEmpty, toDateFormat } from '../composables/utils';

import Sidebar from '@/components/siderbar/SidebarComponent';
import { sidebarWidth } from '@/components/siderbar/state';

    const route = useRoute();
    const id = route.params.id;
    onMounted(() => {
        if(window.$core.data.UserInfo.Metadata?.UnreadBlog > 0){
            window.$core.data.UserInfo.Metadata.UnreadBlog = 0;
        }
        setTimeout(() => {
            //console.log(id)
            if (!isNullOrEmpty(id)) {
                read(id);
                readRecent(6);
            }
            else {
                readPage();
            }
                
        }, 10);
    });

    const { loading, form, list, info, total, pages, readPage, onPageChange, read, readRecent, rencentList } = useInnerBlog();

</script>

<template>
    <div class="wrapper" style="background-color:#fff;" >
        <Sidebar />
        <div class="container blog" :style="{ 'margin-left': sidebarWidth }">
            <div v-if="list!=null" class="max-w-screen-xl mx-auto ">
                <div class="top" style="height:60px;"></div>
                <h4 class="mb-6 font-semibold">Blog</h4>

                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-10 mt-6">
                    <template v-if="loading">
                        <n-card v-for="n in 12" :key="n" class="shadow-sm cursor-pointer hover:bg-slate-50 p-0" size="small" hoverable>
                            <n-skeleton text class="mt-1 w-1/2" />
                            <n-skeleton class="mt-2 h-[160px]" />
                            <n-skeleton text :repeat="2" class="mt-2" />
                            <n-skeleton text class="w-1/2" />
                        </n-card>
                    </template>

                    <n-card v-for="obj in list" class="shadow-sm cursor-pointer hover:bg-slate-50 p-0" :key="`blog-${obj.Id}`" size="small" hoverable>
                        <a :href="`/InnerBlog/${obj.Id}`">
                          
                            <div class="overflow-hidden h-[160px] w-full mt-2" style="position: relative;">
                                <img :src="imageUrl(obj.Photo,560,0,'','max')" class="object-cover w-full h-full" style="border-radius: 4px;" :alt="obj.Title">
                                <div v-if="!obj.IsRead" class="new-blog" style="position: absolute; top: 8px; right: 8px;">new</div>
                            </div>
                            <div class="mt-2" style="display: flex; gap: 4px;">
                                <div class="" style="flex: 1; font-size: 12px;">{{obj.Title}}</div> 
                                <div class="bold" style="font-size: 12px;">{{toDateFormat(obj.CreatedTime,'MMM DD, YYYY')}}</div>
                            </div>
                          
                        </a>
                    </n-card>
                </div>


                <n-pagination v-if="list!=null" v-model:page="form.pageIndex" :page-count="pages" class="flex justify-center !mt-8 mb-8" @update:page="onPageChange" />
            </div>


            <div v-if="info!=null" class="max-w-screen-xl mx-auto " style="background-color: white;">

                <div class="min-h-[500px] ">

                    <div class="top" style="height:60px;"></div>
                    <h4 class="mb-6 font-semibold" >                
                        <a href="/InnerBlog">Blog</a>
                    </h4>

                    
                    <div class="flex md:flex-row flex-wrap">
                        <div class="w-full md:w-3/4 md:pr-6 " v-if="info!=null">
                            <div class="p-8 shadow-md rounded border mb-8">
                                <h1 class="text-lg sm:text-xl md:text-3xl font-bold text-gray-800 mb-4">{{info.Title}}</h1>
                                <div class="text-sm text-gray-500 mb-2">Published on {{toDateFormat(info.CreatedTime,'MMM DD, YYYY')}}</div>
                                <img :src="imageUrl(info.Photo,1200,0,'','max')" class="object-cover w-full h-full rounded" :alt="info.Title">

                                <div v-html="info.Content" class="default-margin text-lg mt-4">
                                </div>

                                <Share v-if="info!=null" :title="info?.Title" />
                            </div>

                        </div>

                        <div class="w-full md:w-1/4 " v-if="rencentList!=null">
                            <n-card v-for="obj in rencentList.filter(m=>m.Id!=id)" :key="`blog-${obj.Id}`" class="shadow-sm cursor-pointer hover:bg-slate-50 p-0 mb-4" size="small" hoverable>
                                <a :href="`/blog/${obj.Id}`">
                                   
                                    <div class="overflow-hidden h-[160px] w-full mt-2">
                                        <img :src="imageUrl(obj.Photo,560,0,'','max')" class="object-cover w-full h-full" :alt="obj.Title">
                                    </div>
                                    <div class="mt-2" style="display: flex; gap: 4px;">
                                        <div class="h-[62px] text-ellipsis overflow-hidden" style="flex: 1; font-size: 12px;">{{obj.Title}}</div> 
                                        <div class="bold" style="font-size: 12px;">{{toDateFormat(obj.CreatedTime,'MMM DD, YYYY')}}</div>
                                    </div>
                                </a>
                            </n-card>
                        </div>
                    </div>


                </div>
            </div>
        </div>

  
    </div>
</template>
<style>
    .blog a {
        text-decoration: none;
        color: inherit;
    }

    .new-blog{background-color: red;
             color: white;
             font-size: 10px;
             font-weight: bold;
             border-radius: 4px;
             padding: 2px 6px;
             margin-left: 8px;
             text-transform: uppercase;
             animation: pulse 1.5s infinite;
            }

    @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.1); opacity: 0.7; }
        100% { transform: scale(1); opacity: 1; }
    }
</style>